export const CREATE_ACCOUNT_QUESTIONS_TRANSLATIONS = {
  POLICY_OR_ACCOUNT_NUMBER: 'Policy or Account Number',
  POLICY_OR_ACCOUNT_NUMBER_VALIDATION: 'Please enter a valid Policy or Account Number',
  PERSONAL_INFORMATION_SUBHEADING: 'Account Information',
  PERSONAL_INFORMATION_DESCRIPTION: 'Please enter your account information below.',
  NAME_SAME_AS_LICENSE: 'Enter your first and last name exactly as they appear on your license.',
  LAST_NAME_HELPER_TEXT: 'Omit any suffixes like Jr., Sr., III, etc.',
  ACTIVATION_EXPIRED_TITLE: 'This activation link has expired',
  ACTIVATION_EXPIRED_MESSAGE: 'Please begin the account creation process again.',
  WHERE_CAN_I_FIND_THIS_INFORMATION: 'Where can I find this information?',
  LOCATE_ACCOUNT_NUMBER_IN_EMAIL: 'Locate your account number in the email',
  LOCATE_ACCOUNT_POLICY_DECLARATIONS: '1. Check your Policy Declarations',
  LOCATE_ACCOUNT_ID_CARD: '2. See your Auto ID Card',
  LOCATE_ACCOUNT_BILLING_STATEMENT: '3. Find them on your Billing Statement'
};
